import mutations from './mutations';
import actions from './actions';

const defaultState = () => {
  return {
    currentProjectId: null,
    info: {},
  };
};

const Project = {
  namespaced: true,
  state: defaultState,
  getters: {
    currentProjectId: (state) => (state.currentProjectId),
    currentProjectTags: (state) => ((state.info && state.info.project_tags) ? state.info.project_tags : []),
  },
  mutations,
  actions,
};

export { Project, defaultState };
